import './Home.css';

import React, { useContext, useEffect } from 'react';
import { SharedVariableContext } from '../../App';
import paypalLogo from "./Assets/Paypal.jpg";
import translations from './Texte';


export default function Home()
{
    // Récupérer les variables et leurs fonctions de mise à jour
    const { MajTypeDePage, MajIllustration, selectedOption } = useContext(SharedVariableContext);

  // Sélectionner la langue, avec français comme langue par défaut
    const lang = translations[selectedOption.value] || translations.fr;

    useEffect(() => {
                    MajTypeDePage('Accueil');
                    MajIllustration('Accueil');
                    }, [MajTypeDePage, MajIllustration]);

    return(
        <div id='Home'>
            <h1>{lang.title}</h1>

            {/* Section Intro */}
            <p>{lang.intro.p1}</p>
            <p>{lang.intro.p2}</p>
            <p>{lang.intro.p3}</p>
            <p>{lang.intro.p4}</p>
            <p>{lang.intro.p5}</p>
            <p>{lang.intro.p6}</p>
            <p>{lang.intro.p7}</p>
            <p>{lang.intro.p8}</p>
            <p>{lang.intro.p9}</p>
            <p>{lang.intro.p10}</p>
            <p>{lang.intro.p11}</p>
            
            <a href="https://paypal.me/amauryz80" className="paypal"><img  src={paypalLogo} alt="Cagnotte Paypal"  /></a>

        </div>

    )
}